var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "burger_svg__a",
    d: "M13.499 10.966a.5.5 0 0 1 .5.5v2.037a.5.5 0 0 1-.5.5H.505a.5.5 0 0 1-.5-.5L0 11.468a.5.5 0 0 1 .5-.5zm0-5.483a.5.5 0 0 1 .492.41l.008.09V8.02a.5.5 0 0 1-.41.492l-.09.008H.505a.5.5 0 0 1-.492-.41l-.008-.089L0 5.984c0-.245.177-.45.41-.493l.09-.008h12.999zm0-5.483a.5.5 0 0 1 .492.41l.008.09v2.036a.5.5 0 0 1-.41.492l-.09.008H.505a.499.499 0 0 1-.492-.409l-.008-.09L0 .502C0 .255.177.05.41.008L.5 0h12.999z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "burger_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#burger_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#burger_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47454A",
    d: "M-2-2h18v18H-2z",
    mask: "url(#burger_svg__b)"
  }))));
};
export default SvgBurger;